/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Umbraco Delivery API
 * You can find out more about the Umbraco Delivery API in [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api).
 * OpenAPI spec version: Latest
 */

export type NewsUmbPageContentModelContentType =
	(typeof NewsUmbPageContentModelContentType)[keyof typeof NewsUmbPageContentModelContentType];

export const NewsUmbPageContentModelContentType = {
	newsUmbPage: "newsUmbPage",
} as const;
